import { hc } from "hono/client";
import type { AppType } from "@wondermaps/api";

/**
 * Hono RPC Client
 *
 * This client provides full type inference for all API endpoints.
 * The types are derived from the API's route definitions via AppType.
 *
 * Usage:
 *   const res = await api.maps[':slug'].$get({ param: { slug: 'demo' } });
 *   const data = await res.json(); // Fully typed!
 */

const baseUrl = import.meta.env.VITE_API_URL || "";

// Client is mounted at /api to match where apiRoutes is mounted
export const api = hc<AppType>(`${baseUrl}/api`, {
  init: { credentials: 'include' }
});

// Re-export types for convenience
export type { AppType };
